import React, { useEffect, useState } from "react";
import Input from "../../components/input";
import useAxiosInstance from "../../hooks/useAxios";
import JsonView from "@uiw/react-json-view";
import { MdCopyAll } from "react-icons/md";
import { toast } from "react-toastify";
import { ModalComp } from '../../components/Modal';
import PlaygroundModel from "../Playground/PlaygroundModel";
import PlaygroundV2Model from "../PlaygroundV2/PlaygroundV2Model";

const CosmosResults = () => {
  const [promptId, setPromptId] = useState(0);
  const [where,setWhere] = useState('');
  const [reportId, setReportId] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [container, setContainer] = useState("ai_prod_6");
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [l1Call, setL1Call] = useState("");
  const [l1Response, setL1Response] = useState("");

  const [promptModel,setPromptModel] = useState(false);
  const [promptModelV2,setPromptModelV2] = useState(false);
  const [promptModelLoading,setPromptModelLoading] = useState(false);
  const axios = useAxiosInstance();
  
  useEffect(()=>{
    setPage(0)
  },[container, reportId, pageSize, promptId, where, l1Call, l1Response])

  const [res, setRes] = useState([]);
  const [perticularView, setPerticularView] = useState({});

  const handleSumit = () => {
    setLoading(true);
    axios
      .post(container.includes("llm_logs")? "/assets/get_clickhouse_llm_logs/":"/assets/get_cosmos_results/", {
        prompt_id: promptId,
        report_id: reportId,
        container: container,
        page_size: Number(pageSize),
        where:where,
        page: page,
        l1_call: l1Call,
        l1_response: l1Response,
      })
      .then((res) => {
        setLoading(false);
        setRes(res.data.data || []);
        setPage((prev) => prev + 1);
      }).catch(err=>{
        toast.info('Wrong query')
      });
  };
  function parseCustomDate(dateString) {
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    const hours = dateString.slice(8, 10);
    const minutes = dateString.slice(10, 12);
    const seconds = dateString.slice(12, 14);
    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
}
const saveTemplateAsFile = (filename, dataObjToWrite) => {
    const blob = new Blob([JSON.stringify(dataObjToWrite)], { type: "text/json" });
    const link = document.createElement("a");

    link.download = filename;
    link.href = window.URL.createObjectURL(blob);
    link.dataset.downloadurl = ["text/json", link.download, link.href].join(":");

    const evt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true,
    });

    link.dispatchEvent(evt);
    link.remove()
};
  

  // v1 states
  const [prompt, setPrompt] = useState("");
  const [v1promptId, setV1PromptId] = useState(0);
  const [temperature, setTemperature] = useState(1);
  const [maxTokens, setMaxTokens] = useState(100);
  const [modelType, setModelType] = useState("");
  const [topP, setTopP] = useState(0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0);
  const [presencePenalty, setPresencePenalty] = useState(0);
  const [engine, setEngine] = useState({});
  const [systemMessage, setSystemMessage] = useState("You are a helpful assistant.");
  const [functions, setFunctions] = useState(null);
  
  //Playground v2 states
  const [prompt_function,set_prompt_function] = useState('');
  const [prompt_text,set_prompt_text] = useState('');
  const [model,set_model] = useState('');
  const [system_prompt,set_system_prompt] = useState('');
  const [max_tokens,set_max_tokens] = useState('');
  return (
    <div>
      <ModalComp
         open={promptModelV2}
        onClose={() => {
          setPromptModelV2(false);
        }}
      >
        {promptModelLoading ? <div></div>:<div className="w-3/4">
        <PlaygroundV2Model
          max_tokens={max_tokens}
          model={model}
          prompt_function={prompt_function}
          prompt_text={prompt_text}
          set_max_tokens={set_max_tokens}
          set_model={set_model}
          set_prompt_function={set_prompt_function}
          set_prompt_text={set_prompt_text}
          set_system_prompt={set_system_prompt}
          system_prompt={system_prompt}
        />
        </div>}
      </ModalComp>
      <ModalComp
        open={promptModel}
        onClose={() => {
          setPromptModel(false);
        }}
      >
        {promptModelLoading ? <div></div>:<div className="w-3/4">
        <PlaygroundModel
          prompt={prompt}
          setPrompt={setPrompt}
          promptId={v1promptId}
          setPromptId={setV1PromptId}
          temperature={temperature}
          setTemperature={setTemperature}
          maxTokens={maxTokens}
          setMaxTokens={setMaxTokens}
          modelType={modelType}
          setModelType={setModelType}
          topP={topP}
          setTopP={setTopP}
          frequencyPenalty={frequencyPenalty}
          setFrequencyPenalty={setFrequencyPenalty}
          presencePenalty={presencePenalty}
          setPresencePenalty={setPresencePenalty}
          engine={engine}
          setEngine={setEngine}
          systemMessage={systemMessage}
          setSystemMessage={setSystemMessage}
          functions={functions}
          setFunctions={setFunctions}
        />
        </div>}
      </ModalComp>
      <div className="mr-4  p-3 my-5 border rounded-lg bg-white">
        <p className="text-2xl text-black font-medium mb-4">Cosmos</p>
        <div className="grid grid-cols-2 gap-x-4">
        <div>
        <p className="text-sm font-semibold text-black mb-2">Prompt ID</p>
        <Input
          value={promptId}
          onChange={(e) => {
            setPromptId(Number(e.target.value));
          }}
          type="Number"
          placeholder="Enter the promptId"
        />
        </div>

        <div>
        <p className="text-sm font-semibold text-black  mb-2">Report ID</p>
        <Input
          value={reportId}
          onChange={(e) => {
            setReportId(Number(e.target.value));
          }}
          type="Number"
          placeholder="Enter the reportId"
        />
        </div>
        </div>

        <div>
        <p className="text-sm font-semibold text-black  mb-2">where</p>
        <Input
          value={where}
          onChange={(e) => {
            setWhere(e.target.value);
          }}
          type="text"
          placeholder="Enter the where(including where)"
        />
        </div>

        <div className="grid grid-cols-2 mt-4 gap-x-4">  
        <div>
        <p className="text-sm font-semibold text-black  mb-2">Page Size</p>
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(e.target.value);
          }}
          className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
          placeholder="Enter your page size"
        >
          <option value={10}>10</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={500}>500</option>
          <option value={1000}>1000</option>
          <option value={9999999999999}>Full</option>
        </select>
        </div>

        <div>
        <p className="text-sm font-semibold text-black  mb-2">Container</p>
        <select
          value={container}
          onChange={(e) => {
            setContainer(e.target.value);
          }}
          className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
          placeholder="Enter your page size"
        >
          <option value={"ai_prod_6"}>ai_prod_6</option>
          <option value={"ai_prod_5"}>ai_prod_5</option>
          <option value={"ai_test_2"}>ai_test_2</option>
          <option value={"ai_test_3"}>ai_test_3</option>
          <option value={"llm_logs.test"}>llm_logs.test</option>
          <option value={"llm_logs.production"}>llm_logs.production</option>
        </select>
        </div>

        <div>
        <p className="text-sm font-semibold text-black mt-4 mb-2">Page Number</p>
        <Input
          value={page}
          onChange={(e) => {
            setPage(Number(e.target.value));
          }}
          type="Number"
          placeholder="Enter Page"
        />
        </div>
       
        </div>
        <div className="grid grid-cols-2 gap-x-4 mt-4">
            <div>
                <p className="text-sm font-semibold text-black mb-2">l1_call</p>
                <Input
                    value={l1Call}
                    disabled = {promptId===0 && reportId===0}
                    onChange={(e) => setL1Call(e.target.value)}
                    type="text"
                    placeholder="Enter l1_call"
                />
            </div>
            <div>
                <p className="text-sm font-semibold text-black mb-2">l1_response</p>
                <Input
                    disabled = {promptId===0 && reportId===0}
                    value={l1Response}
                    onChange={(e) => setL1Response(e.target.value)}
                    type="text"
                    placeholder="Enter l1_response"
                />
            </div>
        </div>

        <button
          onClick={() => {
            handleSumit();
          }}
          className="px-3 my-3 py-3 bg-black rounded-lg text-white disabled:bg-[#b6b6b6]"
        >
          Fire/Next
        </button>
        
        <div 
        onClick={()=>{
            saveTemplateAsFile('prompts.json', res)
          }}
        className="flex justify-end w-full cursor-pointer items-center gap-2">Download all prompts
        </div>
        <div 
        onClick={()=>{
            navigator.clipboard.writeText(JSON.stringify(res))
            toast.success('All prompts Copied')
          }}
        className="flex justify-end w-full cursor-pointer items-center gap-2"><MdCopyAll />Copy all
        </div>

        <div className="grid grid-cols-2 gap-2 ">
        <div>
          <div className="overflow-y-auto h-[60vh] bg-slate-100 p-1 rounded-lg w-full">
            <table className="w-full ">
            {container==='pitchbook' ? <><thead className="border-b text-left">
                <th className="px-2 py-1 text-gray-700 text-sm ">pitchbook_id</th>
                <th className="px-2 py-1 text-gray-700 text-sm ">status</th>
              </thead></>:container==='cbinsights' ?<thead className="border-b text-left">
                
                <th className="px-2 py-1 text-gray-700 text-sm ">cb_insights_id</th>
                <th className="px-2 py-1 text-gray-700 text-sm ">status</th>
                <th className="px-2 py-1 text-gray-700 text-sm ">status_code</th>

              </thead>:container==='tracxn' ?<thead className="border-b text-left">
                <th className="px-2 py-1 text-gray-700 text-sm ">tracxn_id</th>
                <th className="px-2 py-1 text-gray-700 text-sm ">status</th>
                <th className="px-2 py-1 text-gray-700 text-sm ">type</th>
              </thead>:<thead className="border-b text-left">
                <th className="px-2 py-1 text-gray-700 text-sm ">Open in Playground</th>
                <th className="px-2 py-1 text-gray-700 text-sm ">Prompt Id</th>
                <th className="px-2 py-1 text-gray-700 text-sm ">Report ID</th>
                <th className="px-2 py-1 text-gray-700 text-sm ">Date</th>
              </thead>}
            <tbody className="divide-y">
              {loading ? (
                <div className="flex justify-center flex-col items-center">
                  <p>Loading...</p>
                </div>
              ) : (
                res.map((prompt) => {
                  return (
                    container==='pitchbook' ? 
                    <tr className={`cursor-pointer ${perticularView.id === prompt.id ? '!text-green-500':''}`} onClick={() => {
                        setPerticularView(res.find(it=>it.id === prompt.id))
                    }}>
                      <td className="whitespace-nowrap  px-2 py-2 font-medium ">
                        {prompt?.pitchbook_id}
                      </td>
                      <td className="whitespace-nowrap  px-2 py-2 font-medium ">
                        {prompt?.status}
                      </td>
                    </tr>
                    : container==='cbinsights'?<tr className={`cursor-pointer ${perticularView.cb_insights_id === prompt.cb_insights_id ? '!text-green-500':''}`} onClick={() => {
                      setPerticularView(res.find(it=>it.cb_insights_id === prompt.cb_insights_id))
                    }}><td className="whitespace-nowrap  px-2 py-2 font-medium">
                        {prompt.cb_insights_id}
                    </td>
                    <td className="whitespace-nowrap  px-2 py-2 font-medium">
                        {prompt.status}
                    </td>
                    <td className="whitespace-nowrap  px-2 py-2 font-medium">
                        {prompt.status_code}
                    </td>
                    </tr>:container==='tracxn'?<tr className={`cursor-pointer ${perticularView.tracxn_id === prompt.tracxn_id ? '!text-green-500':''}`} onClick={() => {
                      setPerticularView(res.find(it=>it.tracxn_id === prompt.tracxn_id))
                    }}><td className="whitespace-nowrap  px-2 py-2 font-medium">
                        {prompt.tracxn_id}
                    </td>
                    <td className="whitespace-nowrap  px-2 py-2 font-medium">
                        {prompt.status}
                    </td>
                    <td className="whitespace-nowrap  px-2 py-2 font-medium">
                        {prompt.type}
                    </td>
                    </tr>:
                    <tr className={`cursor-pointer ${perticularView.id === prompt.id ? '!text-green-500':''}`} onClick={() => {
                        setPerticularView(res.find(it=>it.id === prompt.id))
                    }}>
                      <td className="whitespace-nowrap  px-2 py-2 font-medium">
                        <button className="bg-black px-2 py-1 text-white text-sm cursor-pointer" onClick={()=>{
                          setPromptModelLoading(true)  
                          const mode = Object.keys(prompt || {}).includes('l1_response') ? 'v1' : 'v2'
                          if(mode === 'v1'){
                            setPromptModel(true)
                          }else{
                            setPromptModelV2(true)
                          }
                          axios.get(`assets/get_prompt_details?prompt_id=${prompt?.prompt_id}&mode=${mode}`).then(res=>{
                            setPromptModelLoading(false)
                            if(mode==='v1'){
                              setPrompt(prompt?.l1_call)
                              setV1PromptId(res?.data?.prompt_id)
                              setTemperature(res?.data?.temperature)
                              setMaxTokens(res?.data?.max_tokens)
                              setModelType(res?.data?.model_type)
                              setTopP(res?.data?.top_p)
                              setFrequencyPenalty(res?.data?.frequency_penalty)
                              setPresencePenalty(res?.data?.presence_penalty)
                              setEngine({"name":res?.data?.engine})
                              setSystemMessage(res?.data?.system_message)
                              setFunctions(JSON.stringify(res?.data?.function))                           
                            }else{
                              set_prompt_text(prompt?.prompt?.messages?.[1]?.content)
                              set_prompt_function(res?.data?.prompt_function ? JSON.stringify(res?.data?.prompt_function):'')
                              set_model(res.data?.model)
                              set_system_prompt(res.data?.system_prompt)
                              set_max_tokens(res.data?.max_tokens)
                          }
                          }).catch(err=>{console.log(err)})
                        }}>Open</button>
                      </td>
                      <td className="whitespace-nowrap  px-2 py-2 font-medium">
                        {prompt?.prompt_id}
                      </td>
                      <td className="whitespace-nowrap  px-2 py-2 font-medium">
                        {prompt?.report_id}
                      </td>
                      <td className="whitespace-nowrap  px-2 py-2 font-medium">
                        {parseCustomDate(prompt?.dt||'')}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
            </table>
          </div>
        </div>
        <div className="mt-3 h-[60vh] overflow-y-auto">
          <div className="flex justify-end w-full cursor-pointer"><MdCopyAll onClick={()=>{
            navigator.clipboard.writeText(JSON.stringify(perticularView))
            toast.success('This prompt Copied')
          }}/></div>
          <JsonView
            shortenTextAfterLength={0}
            value={perticularView}
            displayObjectSize={false}
            displayDataTypes={false}
          />
        </div>
        </div>
      </div>
    </div>
  );
};

export default CosmosResults;
